import { render } from "./DocumentationView.vue?vue&type=template&id=3f8263ee&scoped=true"
const script = {}

import "./DocumentationView.vue?vue&type=style&index=0&id=3f8263ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8263ee"]])

export default __exports__